import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'
import { getDefaultStore } from 'jotai'
import { isAuthenticatedAtom, waitForAuthInit } from '@/store/auth.atom'
import { LoginPage } from '@/pages/auth/LoginPage'

const loginSearchSchema = z.object({
  redirect: z.string().optional().catch(undefined),
})

export const Route = createFileRoute('/(public)/login')({
  validateSearch: loginSearchSchema,
  beforeLoad: async ({ search }) => {
    if (typeof window === 'undefined') return

    await waitForAuthInit()
    if (getDefaultStore().get(isAuthenticatedAtom)) {
      throw redirect({ to: search.redirect || '/dashboards' })
    }
  },
  component: LoginPage,
})